import { connect } from "react-redux";
import PropTypes from "prop-types";

// Components
import BaseInputComponent from "basecomponents/BaseInputComponent";
import { InputField } from "../components/form";
import { Button } from "../components/button";
import Table from "../components/table";
import PaginationBar from "../components/paginationBar";

// Modals
import AdminAddArticleModal from "modals/AdminAddArticleModal";
import AdminEditArticleModal from "modals/AdminEditArticleModal";

// Interfaces
import { IArticle } from "../interfaces/IPackage";

// Actions
import {
  getAllArticles,
  setEditArticleFromFunction,
  deleteArticle,
  markArticleReceived,
} from "../actions/articleActions";
import { getAbsClients } from "../actions/clientActions";
import { getAbsPackages } from "../actions/packageActions";

// Utils
import { showModal, showPopUpConfirmation } from "../utils/domUtils";
import { getArticleStatus } from "../utils/packageUtils";
class AdminDArticles extends BaseInputComponent {
  state = {
    field: "",
  };

  idmodal_add_article = "modal_add_article";
  idmodal_edit_article = "modal_edit_article";

  componentDidMount() {
    this.searchConfig.getResultsFunctionName = "getAllArticles";
    this.searchConfig.propsObjectName = "article";
    this.getResultsForComponent({
      from: 0,
    });
    // @ts-ignore
    this.props.getAbsClients();
    // @ts-ignore
    this.props.getAbsPackages();
  }

  onTablePageClick = (newPage) => {
    this.getResultsForComponent({ currentPage: newPage });
  };

  onKeyUpField = () => {
    this.handleSearchField(this.state.field);
  };

  isLoading(): boolean {
    // @ts-ignore
    return this.props.article.loading;
  }

  getComponentResults(): Array<IArticle> {
    // @ts-ignore
    const results: Array<IArticle> = this.props.article.elements;
    return results;
  }

  onAddArticleClick = () => {
    showModal(this.idmodal_add_article);
  };

  onMarkAsReceivedClick = (article: IArticle) => {
    // @ts-ignore
    this.props.markArticleReceived(article.id);
  };

  onEditArticleClick = (article: IArticle) => {
    // @ts-ignore
    this.props.setEditArticleFromFunction(article);
    showModal(this.idmodal_edit_article);
  };

  onDeleteArticleClick = (article: IArticle) => {
    showPopUpConfirmation(
      `Realmente desea elminar el articulo "${article.name}"?`,
      `El articulo con tracking "${article.track_code}" sera eliminado.\nEsta accion removera el articulo y no podra ser utilizado nuevamente`,
      (confirmation) => {
        if (!confirmation) return;
        this.onConfirmDeleteClient(article);
      }
    );
  };

  onConfirmDeleteClient = (article: IArticle) => {
    // @ts-ignore
    this.props.deleteArticle(article.id);
  };

  getInputSearch = () => {
    const { field } = this.state;
    return (
      <div className="input-search mb-2">
        <InputField
          id="field"
          name="field"
          placeholder="Buscar..."
          value={field}
          onChange={this.onChangeTextInput}
          onKeyUp={this.onKeyUpField}
        />
      </div>
    );
  };

  getResultsTable = () => {
    return (
      <>
        <Table
          isLoading={this.isLoading()}
          results={this.getComponentResults()}
          headers={[
            "",
            "ID",
            "Tracking",
            "Articulo",
            "Recibido",
            "Estado",
            "Cliente",
            "Fecha de creaci&oacute;n",
          ]}
          getRowFN={this.getResultsTableRow}
        />
        <PaginationBar
          pagination={
            // @ts-ignore
            this.props.article.pagination
          }
          onPageClick={this.onTablePageClick}
        />
      </>
    );
  };

  getResultsTableRow = (article: IArticle, uuid_key) => {
    return (
      <tr key={uuid_key}>
        <td>
          <div className="dropdown">
            <button
              className="btn btn-link"
              type="button"
              id={`dropdown_${article.id}`}
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <i className="feather icon-more-vertical-"></i>
            </button>
            <div
              className="dropdown-menu"
              aria-labelledby={`dropdown_${article.id}`}
            >
              <a
                className="dropdown-item"
                href="#!"
                onClick={this.onMarkAsReceivedClick.bind(this, article)}
              >
                <i className="feather icon-check mr-2"></i>Marcar como recibido
              </a>
              <a
                className="dropdown-item"
                href="#!"
                onClick={this.onEditArticleClick.bind(this, article)}
              >
                <i className="feather icon-edit-2 mr-2"></i>Editar
              </a>
              <a
                className="dropdown-item"
                href="#!"
                onClick={this.onDeleteArticleClick.bind(this, article)}
              >
                <i className="feather icon-trash mr-2"></i>Eliminar
              </a>
            </div>
          </div>
        </td>
        <td>{article.id}</td>
        <td>{article.track_code}</td>
        <td>{article.name}</td>
        <td>{article.received ? "Si" : "No"}</td>
        <td>{getArticleStatus(article.status)}</td>
        <td>
          {article.client_code
            ? `${article.client_code} ${article.client_name}`
            : ""}
        </td>
        <td>{article.created_date}</td>
      </tr>
    );
  };

  render() {
    return (
      <>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-header">
                <div className="card-title">
                  <span>Listado de articulos</span>
                  <Button
                    icon="icon-plus"
                    extraClass="btn-primary pull-right"
                    onClick={this.onAddArticleClick}
                  />
                </div>
                <div className="card-body">
                  {this.getInputSearch()}
                  {this.getResultsTable()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <AdminAddArticleModal />
        <AdminEditArticleModal />
      </>
    );
  }
}

// @ts-ignore
AdminDArticles.propTypes = {
  article: PropTypes.object.isRequired,
  getAllArticles: PropTypes.func.isRequired,
  setEditArticleFromFunction: PropTypes.func.isRequired,
  deleteArticle: PropTypes.func.isRequired,
  getAbsClients: PropTypes.func.isRequired,
  getAbsPackages: PropTypes.func.isRequired,
  markArticleReceived: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  article: state.article,
});

export default connect(mapStateToProps, {
  getAllArticles,
  deleteArticle,
  setEditArticleFromFunction,
  getAbsClients,
  getAbsPackages,
  markArticleReceived,
})(AdminDArticles);
